/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Goodforfamily2Inputs */

const en_goodforfamily2 = /** @type {(inputs: Goodforfamily2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Family`)
};

const de_goodforfamily2 = /** @type {(inputs: Goodforfamily2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Familie`)
};

/**
* | output |
* | --- |
* | "Family" |
*
* @param {Goodforfamily2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const goodforfamily2 = /** @type {((inputs?: Goodforfamily2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Goodforfamily2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_goodforfamily2(inputs)
	return de_goodforfamily2(inputs)
});
export { goodforfamily2 as "goodForFamily" }